<template>
    <div class="animated fadeIn">
        <div>
            <component-header
                :title="`${
                    partnerAllData && partnerAllData.authentication
                        ? partnerAllData.authentication.userName
                        : ''
                } - View Subscription`"
                :isLoading="isloading"
                @reload-data="getPartnerSubcriptionListData"
                :hasUnbilliedInvoice="false"
                :hasSearch="false"
                :hasback="true"
                @back-press="$router.push('./basic-info')"
                @create-press="$router.push({ name: 'create-subscription' })"
            />
            <b-card class="card-wrap mt-2" border-variant="info">
                <div>
                    <b-table
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive
                        :items="subscriptionItemList"
                        :fields="subscriptionColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        show-empty
                    >
                        <template slot-scope="data" slot="cell(action)">
                            <b-button
                                @click="deletePlan(data.item)"
                                size="sm"
                                class="mr-2 my -0 main-navigation-button"
                                variant="danger"
                            >
                                Cancel
                            </b-button>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="isloading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>

                        <template slot="cell(status)" slot-scope="data">
                            <div v-if="data.item.status == 'ACTIVE'">
                                <img
                                    class="mr-1"
                                    src="img/Ellipse63.png"
                                    alt=""
                                />
                                Active
                            </div>
                            <div v-if="data.item.status == 'INACTIVE'">
                                <img
                                    class="mr-1"
                                    src="img/Ellipse6.png"
                                    alt=""
                                />
                                Inactive
                            </div>
                            <div v-if="data.item.status == 'PENDING'">
                                <img
                                    class="mr-1"
                                    src="img/orangeStatus.png"
                                    alt=""
                                />Pending
                            </div>
                        </template>
                    </b-table>
                </div>
               <div style="float: right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="subscriptionItemList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                    ></b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import moment from "moment";
export default {
    name: "ViewSubscription",
    data() {
        return {
            isloading: false,
            currentPage: 1,
            perPage: 8,
            subscriptionColumns: [
                {
                    key: "name",
                },
                {
                    key: "startDate",
                },
                {
                    key: "invoicedUpto",
                },
                {
                    key: "nextBillDate",
                },
                {
                    key: "lastBillDate",
                },
                {
                    key: "rate",
                },
                {
                    key: "description",
                },
                {
                    key: "status",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    components: {
        ebButton,
        ComponentHeader,
    },
    computed: {
        ...mapGetters({
            subscriptionList: "subscription/GetSubscriptionList",
            partnerAllData: "partner/GetPartnerData",
            partnerSubscribedList: "subscription/GetSubscriptionPartnerList",
        }),
        subscriptionItemList() {
            let data = this.partnerSubscribedList;
            let subscriptionList = this.subscriptionList;

            let subscribedList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((obj) => {
                    try {
                        let selectedPlan = subscriptionList.filter(
                            (element) => {
                                return element._id == obj.plan;
                            },
                        );

                        let arrObj = {
                            _id: obj._id,
                            name: selectedPlan[0].planName,
                            startDate: this.getProperDate(obj.activationDate),
                            chargeTo: this.getProperDate(obj.chargeTo),
                            invoicedUpto: this.getProperDate(obj.chargeTo),
                            nextBillDate: this.getProperDate(obj.nextBillDate),
                            lastBillDate: this.getProperDate(obj.lastBillDate),
                            rate: this.cedencePriceSet(obj),
                            description: selectedPlan[0].planDescription,
                            status: obj.status,
                            planUser: obj.user,
                            restData: obj,
                        };
                        subscribedList.push(arrObj);
                    } catch (err) {}
                });
                return subscribedList.sort(
                    (a, b) =>
                        new Date(b.restData.updatedAt) -
                        new Date(a.restData.updatedAt),
                );
            } else {
                return [];
            }
        },
    },

    methods: {
        async deletePlan(data) {
            let payload = {
                user: data.planUser,
                subscription: data._id,
            };
            this.$swal({
                title: "Cancel this Subscription?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                cancelButtonText: "Cancel",
                cancelButtonColor: "#3085d6",
                confirmButtonColor: "#d33",
                confirmButtonText: "Yes, Cancel it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "subscription/partnerSubscriptionDelete",
                            payload,
                        )
                        .then((result) => {
                            this.getPartnerSubcriptionListData();
                            this.$swal({
                                title: "Success",
                                text: "Subscription Canceled Successfully!",
                                type: "success",
                            });
                        })
                        .catch((err) => {
                            //
                        });
                }
            });

            // await this.$store
            //   .dispatch("subscription/partnerSubscriptionDelete", payload)
            //   .then(result => {
            //     this.getPartnerSubcriptionListData();
            //     this.$swal({
            //       title: "Success",
            //       text: "Subscription Canceled Successfully!",
            //       type: "success"
            //     });
            //   })
            //   .catch(err => {
            //     console.log("err", err);
            //   });
        },

        cedencePriceSet(obj) {
            if (obj.pricing.cadence == "EVENT") {
                return (obj.pricing.price * 100).toFixed(2);
            } else {
                return obj.pricing.price.toFixed(2);
            }
        },
        async getPartnerSubcriptionListData() {
            this.isloading = true;
            await this.$store
                .dispatch("subscription/getSubscriptionPartner", {
                    id: this.$route.params.id,
                    data: {},
                })
                .then((data) => {
                    if (data.message) {
                        this.$toasted.error(data.message);
                        this.isloading = false;
                    }
                    this.isloading = false;
                })
                .catch((err) => {
                    this.isloading = false;
                });
        },
        getProperDate(data) {
            if (data != null) {
                let date = new Date(data);

                return moment(String(date)).format("DD/MM/YYYY");
            } else {
                return "Unavailable";
            }
        },
    },
    async mounted() {
        this.isloading = true;
        if (this.partnerAllData == null) {
            await this.$store.dispatch(
                "partner/fetchPartnerById",
                this.$route.params.id,
            );
        }
        await this.$store.dispatch("subscription/getSubscriptionPartner", {
            id: this.$route.params.id,
            data: {},
        });
        await this.$store.dispatch("subscription/fetchSubscriptionList");
        this.isloading = false;
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
